import { ColorContext, LayoutSizeContext } from 'App';
import React, { useContext } from 'react';
import { IconContext } from 'react-icons';

export default function OvalDisplay({
  time,
  temp,
  icon,
  selected,
  style,
  iconStyle,
  timeStyle,
  tempStyle,
}) {
  const layout = useContext(LayoutSizeContext);

  const theme = useContext(ColorContext);
  return (
    <div
      className="rounded-pill p-3 w-100 h-100 flex-col align-content-center align-items-center justify-content-center "
      style={{
        backgroundColor: theme.primary,

        border: selected ? 'solid white 2px' : 'solid rgba(0,0,0,0) 2px',
        boxSizing: 'border-box',
        justifyContent: 'center',
        ...style,
      }}
    >
      <div
        style={{
          fontSize: layout.baseFontSize,
          color: theme.fontColor,
          ...timeStyle,
        }}
      >
        {time}
      </div>
      <div
        className="d-flex justify-content-center align-items-center "
        style={{
          width: 50 * layout.scaleMult,
          height: 50 * layout.scaleMult,
          margin: '0 auto',
          ...iconStyle,
        }}
      >
        <IconContext.Provider
          value={{
            color: theme.fontColor,
            size: '100%',
          }}
        >
          {icon}
        </IconContext.Provider>
      </div>
      <div
        style={{
          fontSize: layout.baseFontSize,
          color: theme.fontColor,
          ...tempStyle,
        }}
      >
        {temp}
      </div>
    </div>
  );
}
